/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Dashboard_Age_Month_RangeInputs */

const en_dashboard_age_month_range = /** @type {(inputs: Dashboard_Age_Month_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start}–${i?.end} mo`)
};

const pt_br2_dashboard_age_month_range = /** @type {(inputs: Dashboard_Age_Month_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start}–${i?.end} meses`)
};

/**
* | output |
* | --- |
* | "{start}–{end} mo" |
*
* @param {Dashboard_Age_Month_RangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_age_month_range = /** @type {((inputs: Dashboard_Age_Month_RangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Age_Month_RangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_age_month_range(inputs)
	return pt_br2_dashboard_age_month_range(inputs)
});